import { useModuleAccess } from '@/hooks/useAccountModules';

/**
 * Meta Ads is an opt-in feature of the Marketing module, switched on per
 * account in Corp-App's Module Settings (Marketing → Opt-in features). Off for
 * every account until then — Meta's App Review is still pending. The API
 * enforces the same switch (MarketingIntegration::isEnabled), so this only
 * decides what to show.
 */
export const META_ADS_FEATURE = 'meta-ads';

/** Nav key for NavItemDef.requiresModuleFeature. */
export const META_ADS_NAV_FEATURE = `marketing/${META_ADS_FEATURE}`;

export interface MetaAdsAccess {
  enabled: boolean;
  /** A fresh /account/modules answer is in, so `enabled` can be trusted. */
  known: boolean;
  /**
   * The latest /account/modules fetch failed and none is running, so `known`
   * will not turn true by itself (the query has `retry: false`).
   */
  failed: boolean;
  retry: () => void;
}

export function useMetaAdsEnabled(): MetaAdsAccess {
  const marketing = useModuleAccess('marketing');
  return {
    enabled: marketing.enabledFeatures.includes(META_ADS_FEATURE),
    known: marketing.isFresh,
    failed: marketing.loadFailed === true,
    retry: () => marketing.retry?.(),
  };
}
